import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FlexBox } from '@brg/ui';
import styled from 'styled-components';

const Blur = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const AlertWrapper = styled(FlexBox)`
    max-width: 105px;
    padding: 8px 10px;
    place-items: center;
    position: relative;
    opacity: 0;

    ${Blur} {
        border-radius: 5px;
        background: #151514;
        z-index: 1;
        opacity: 0.47;
        backdrop-filter: blur(12px);
    }

    span {
        z-index: 2;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        color: ${p => p?.theme?.icon.rejectedColor};
        margin-left: 5px;
    }
    svg {
        z-index: 2;
        fill: ${p => p?.theme?.icon.rejectedColor};
    }
`;

type IProps =  {
    fill?: string;
}

export const AlertBlock: FC<IProps> = ({ fill }) => {
    const { t } = useTranslation();
    return (
        <AlertWrapper direction='row' directionMobile={'row'} className="alert-block">
            <Blur />
            <FlexBox>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.55065 11.3717C8.55065 11.6786 8.30301 11.9279 7.99726 11.9279C7.69221 11.9279 7.44387 11.6786 7.44387 11.3717C7.44387 11.064 7.69221 10.8147 7.99726 10.8147C8.30301 10.8147 8.55065 11.064 8.55065 11.3717ZM7.58292 9.45856V6.16012C7.58292 5.93027 7.7683 5.74348 7.99726 5.74348C8.22622 5.74348 8.41231 5.93027 8.41231 6.16012V9.45856C8.41231 9.6891 8.22622 9.8752 7.99726 9.8752C7.7683 9.8752 7.58292 9.6891 7.58292 9.45856ZM14.3328 13.232C14.1142 13.609 13.7255 13.8333 13.2918 13.8333H13.2883L2.69862 13.7986C2.26353 13.7972 1.87477 13.5702 1.65757 13.1903C1.44037 12.8091 1.44176 12.3556 1.66104 11.9758L6.98526 2.77002C7.20453 2.39296 7.5933 2.16797 8.02702 2.16797H8.03185C8.46695 2.16936 8.85638 2.39712 9.07359 2.77766L14.3377 12.0175C14.5549 12.3987 14.5528 12.8528 14.3328 13.232ZM15.0577 11.6036L9.79368 2.36379C9.42844 1.72146 8.76994 1.33676 8.03463 1.33398H8.02702C7.29447 1.33398 6.63664 1.71453 6.26795 2.35199L0.943702 11.5578C0.572936 12.1973 0.570861 12.9625 0.937478 13.6049C1.3034 14.2458 1.96125 14.6298 2.69586 14.6319L13.2855 14.6673H13.2918C14.0243 14.6673 14.6808 14.2875 15.0501 13.6514C15.4216 13.0119 15.4243 12.2466 15.0577 11.6036Z" fill={fill || "#F2F2F2"}/>
                </svg>
            </FlexBox>
            <span>{t('rejected_project')}</span>
        </AlertWrapper>
    )
}

import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FlexBox } from '@brg/ui';
import styled from 'styled-components';

const Blur = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const AlertWrapper = styled(FlexBox)`
    max-width: 105px;
    padding: 8px 10px;
    place-items: center;
    position: relative;
    opacity: 0;

    ${Blur} {
        border-radius: 5px;
        background: #151514;
        z-index: 1;
        opacity: 0.47;
        backdrop-filter: blur(12px);
    }

    span {
        z-index: 2;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        color: ${p => p?.theme?.icon.rejectedColor};
        margin-left: 5px;
    }
    svg {
        z-index: 2;
        fill: ${p => p?.theme?.icon.rejectedColor};
    }
`;

type IProps =  {
    fill?: string;
}

export const AlertBlock: FC<IProps> = ({ fill }) => {
    const { t } = useTranslation();
    return (
        <AlertWrapper direction='row' directionMobile={'row'} className="alert-block">
            <Blur />
            <FlexBox>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.55065 11.3717C8.55065 11.6786 8.30301 11.9279 7.99726 11.9279C7.69221 11.9279 7.44387 11.6786 7.44387 11.3717C7.44387 11.064 7.69221 10.8147 7.99726 10.8147C8.30301 10.8147 8.55065 11.064 8.55065 11.3717ZM7.58292 9.45856V6.16012C7.58292 5.93027 7.7683 5.74348 7.99726 5.74348C8.22622 5.74348 8.41231 5.93027 8.41231 6.16012V9.45856C8.41231 9.6891 8.22622 9.8752 7.99726 9.8752C7.7683 9.8752 7.58292 9.6891 7.58292 9.45856ZM14.3328 13.232C14.1142 13.609 13.7255 13.8333 13.2918 13.8333H13.2883L2.69862 13.7986C2.26353 13.7972 1.87477 13.5702 1.65757 13.1903C1.44037 12.8091 1.44176 12.3556 1.66104 11.9758L6.98526 2.77002C7.20453 2.39296 7.5933 2.16797 8.02702 2.16797H8.03185C8.46695 2.16936 8.85638 2.39712 9.07359 2.77766L14.3377 12.0175C14.5549 12.3987 14.5528 12.8528 14.3328 13.232ZM15.0577 11.6036L9.79368 2.36379C9.42844 1.72146 8.76994 1.33676 8.03463 1.33398H8.02702C7.29447 1.33398 6.63664 1.71453 6.26795 2.35199L0.943702 11.5578C0.572936 12.1973 0.570861 12.9625 0.937478 13.6049C1.3034 14.2458 1.96125 14.6298 2.69586 14.6319L13.2855 14.6673H13.2918C14.0243 14.6673 14.6808 14.2875 15.0501 13.6514C15.4216 13.0119 15.4243 12.2466 15.0577 11.6036Z" fill={fill || "#F2F2F2"}/>
                </svg>
            </FlexBox>
            <span>{t('rejected_project')}</span>
        </AlertWrapper>
    )
}

